import { trim, isType, isJosn } from "@utils";

const doc = window.document;

function get(key) {
  if (!key || !_has(key)) {
    return null;
  }
  let regexpStr =
    "(?:^|.*;\\s*)" +
    encodeURI(key).replace(/[-.+*]/g, "\\$&") +
    "\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*";
  let regexpVal = decodeURI(doc.cookie.replace(new RegExp(regexpStr), "$1"));
  let cookieVal = regexpVal && isJosn(regexpVal) ? JSON.parse(regexpVal) : null;
  return cookieVal ? cookieVal : _localGet(key);
}

function all() {
  let cookies = doc.cookie.split(/; ?/g),
    data = {};
  for (let i = cookies.length - 1; i >= 0; i--) {
    if (!trim(cookies[i])) {
      continue;
    }
    let kvp = cookies[i].split("=");
    let key = decodeURI(kvp[0]);
    data[key] = decodeURI(kvp[1]);
  }
  return data ? data : _localAll();
}

function set(key, data, time) {
  let expires = "Tue, 19 Jan 2038 03:14:07 GMT";
  let tp = false;
  let newDate = "";
  if (time) {
    let date;
    if (isType(time, "Date")) {
      date = time;
    } else if (typeof time === "number" && time < 1000000000000) {
      // eslint-disable-next-line prettier/prettier
      date = formatDate(new Date().getTime() + (time * 1000));
    } else {
      date = formatDate(time);
      tp = true;
      newDate = new Date(formatDate(time + 28800000).replace(/-/g, "/"));
      console.log(newDate);
    }
    expires = date;
  }
  let expiresds = new Date(expires.replace(/-/g, "/"));
  _localSet(key, data, tp ? newDate : expiresds);
  data = JSON.stringify(data);
  doc.cookie =
    encodeURI(key) +
    "=" +
    encodeURI(data) +
    "; expires=" +
    expiresds +
    "; path=/";
}

function formatDate(date) {
  var dates = new Date(date);
  var YY = dates.getFullYear() + "-";
  var MM =
    (dates.getMonth() + 1 < 10
      ? "0" + (dates.getMonth() + 1)
      : dates.getMonth() + 1) + "-";
  var DD = dates.getDate() < 10 ? "0" + dates.getDate() : dates.getDate();
  var hh =
    (dates.getHours() < 10 ? "0" + dates.getHours() : dates.getHours()) + ":";
  var mm =
    (dates.getMinutes() < 10 ? "0" + dates.getMinutes() : dates.getMinutes()) +
    ":";
  var ss =
    dates.getSeconds() < 10 ? "0" + dates.getSeconds() : dates.getSeconds();
  return YY + MM + DD + " " + hh + mm + ss;
}

function remove(key) {
  if (!key || !_has(key)) {
    return;
  }
  doc.cookie =
    encodeURI(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
  _localRemove(key);
}

function clearAll() {
  Object.keys(all()).forEach(function(key) {
    remove(key);
  });
  _localClearAll();
}

function _has(key) {
  let cookieHas = new RegExp(
    "(?:^|;\\s*)" + encodeURI(key).replace(/[-.+*]/g, "\\$&") + "\\s*\\="
  ).test(doc.cookie);

  return cookieHas ? cookieHas : _localHas(key);
}

function _localStorage() {
  return window.localStorage;
}

function _localGet(key) {
  let getData = JSON.parse(_localStorage().getItem(key));
  if (new Date().getTime() >= getData.expires) {
    _localRemove(key);
    return null;
  }
  return getData.value;
}

function _localSet(key, data, time) {
  let insertData = { value: data, expires: time.getTime() };
  return _localStorage().setItem(key, JSON.stringify(insertData));
}

function _localAll() {
  const data = {};
  for (var i = _localStorage().length - 1; i >= 0; i--) {
    var key = _localStorage().key(i);
    data[key] = get(key);
  }
  return data;
}

function _localRemove(key) {
  return _localStorage().removeItem(key);
}

function _localClearAll() {
  return _localStorage().clear();
}

function _localHas(key) {
  return _localStorage().getItem(key) !== null && _localGet(key) !== null;
}

export default {
  get,
  all,
  set,
  remove,
  clearAll,
  has: _has
};
